import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ButtonColorTestPage() {
  return <div className="w-full min-h-screen bg-white py-12 px-6" data-id="element-680">
      <div className="max-w-4xl mx-auto" data-id="element-681">
        {/* Back button */}
        <div className="mb-8" data-id="element-682">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-683">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-684" />
            <span data-id="element-685">Go Back</span>
          </Link>
        </div>
        {/* Main content */}
        <div className="bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-686">
          <h1 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-687">
            CTA Button Color Options
          </h1>
          <div className="space-y-12" data-id="element-688">
            {/* Sunset Coral */}
            <div className="space-y-6" data-id="element-689">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-690">
                Sunset Coral (#f46b5b)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-691">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-692">
                  <span data-id="element-693">Primary Button</span>
                </button>
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-694">
                  <span data-id="element-695">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-696" />
                </button>
                <button className="border-2 border-[#f46b5b] text-[#f46b5b] px-6 py-3 rounded-md font-medium hover:bg-[#f46b5b] hover:text-white transition-colors" data-id="element-697">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Golden Amber */}
            <div className="space-y-6" data-id="element-698">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-699">
                Golden Amber (#f6b736)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-700">
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-701">
                  <span data-id="element-702">Primary Button</span>
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-703">
                  <span data-id="element-704">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-705" />
                </button>
                <button className="border-2 border-[#f6b736] text-[#f6b736] px-6 py-3 rounded-md font-medium hover:bg-[#f6b736] hover:text-white transition-colors" data-id="element-706">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Bright Sky Blue */}
            <div className="space-y-6" data-id="element-707">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-708">
                Bright Sky Blue (#4dc4f7)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-709">
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-710">
                  <span data-id="element-711">Primary Button</span>
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-712">
                  <span data-id="element-713">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-714" />
                </button>
                <button className="border-2 border-[#4dc4f7] text-[#4dc4f7] px-6 py-3 rounded-md font-medium hover:bg-[#4dc4f7] hover:text-white transition-colors" data-id="element-715">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Comparison Section */}
            <div className="pt-10 border-t border-gray-200" data-id="element-716">
              <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-717">
                Side-by-Side Comparison
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-718">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-719">
                  <span data-id="element-720">Sunset Coral</span>
                  <ArrowRightIcon size={18} data-id="element-721" />
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-722">
                  <span data-id="element-723">Golden Amber</span>
                  <ArrowRightIcon size={18} data-id="element-724" />
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-725">
                  <span data-id="element-726">Bright Sky Blue</span>
                  <ArrowRightIcon size={18} data-id="element-727" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}